var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pagedetail"}},[_c('div',{staticClass:"cent"},[_c('topinfo'),_c('navbar'),_c('page',{attrs:{"iteminfo":_vm.iteminfo}})],1),_c('banquan')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }